// extracted by mini-css-extract-plugin
export default {"points":"Score_points__+HJIi","icon":"Score_icon__xQp3F"};